import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, mergeMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { HistoryLogRelevanceActions } from './history-log-relevance.actions';
import { HistoryLogRelevanceService } from '../../service/history-log-relevance.service';


@Injectable()
export class HistoryLogRelevanceEffects {
 loadRiskMapHistoryLog$ = createEffect(
        (rs: HistoryLogRelevanceService = inject(HistoryLogRelevanceService)) => {
            return this.actions$.pipe(

                ofType(HistoryLogRelevanceActions.loadRelevanceHistoryLog),
                mergeMap(({ parameters, legalEntityId, campaignId }) =>
                    rs.fetchRelevanceHistoryLog(parameters, legalEntityId, campaignId).pipe(
                        map((historyLog) => {
                            return HistoryLogRelevanceActions.loadRelevanceHistoryLogSuccess({
                                historyLog
                            });
                        }),
                        catchError((error) => of(HistoryLogRelevanceActions.loadRelevanceHistoryLogFailure({ error })))
                    )
                )
            );
        },
        { functional: true }
    );


  constructor(private actions$: Actions) {}
}
